import { createFileRoute } from '@tanstack/react-router'
import { BookingEditorPage } from '@/features/bookings/editor'

export const Route = createFileRoute('/bookings_/new')({
  component: BookingEditorPage,
})
